import { CdkDrag } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { DebugColor } from '@models';
import {
  AppService,
  CanvasService,
  DebugRenderService,
  DetectionService,
  MetricsService,
} from '@services';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-debug',
  templateUrl: './debug.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule, CdkDrag],
})
export class DebugComponent {
  protected appService = inject(AppService);
  private canvasService = inject(CanvasService);
  private detectionService = inject(DetectionService);
  protected debugRenderService = inject(DebugRenderService);
  protected metricsService = inject(MetricsService);

  fillColor = Object.entries(DebugColor).map(([key, value]) => value);

  showPerformance = signal(false);
  showMetrics = signal(false);
  showRegressions = signal(true);

  workerPerformances = computed(() =>
    Object.entries(this.detectionService.workerPerformances()).map((entry) => ({
      id: entry[0],
      cycleTime: entry[1].cycleTime,
      color:
        this.fillColor[this.detectionService.workerIds().indexOf(entry[0])],
    })),
  );

  toolPaths = computed(() =>
    Object.entries(this.metricsService.toolPaths()).map((entry) => ({
      id: entry[0],
      distance: entry[1],
    })),
  );

  filterChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.canvasService.objectFilter = inputElement.value
      .split(',')
      .map((item) => item.trim());
  }

  toggleWorker(worker: string) {
    this.debugRenderService.workerFilter =
      this.debugRenderService.workerFilter.includes(worker)
        ? this.debugRenderService.workerFilter.filter((item) => item !== worker)
        : [...this.debugRenderService.workerFilter, worker];
  }
}
